import React, { useEffect, useState } from 'react';

const JobsDe = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <p>Laden...</p>;
  if (error) return <p>Fehler: {error.message}</p>;

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 text-center">
          <h1 className="mb-4">Karrieremöglichkeiten</h1>
          
          <div className="card shadow-sm">
            <div className="card-body py-5">
              <i className="fas fa-briefcase fa-3x text-muted mb-4"></i>
              <h3 className="mb-3">Derzeit keine offenen Stellen</h3>
              <p className="lead text-muted mb-4">
                Wir haben derzeit keine neuen Stellenausschreibungen verfügbar. Wir sind jedoch 
                immer daran interessiert, von talentierten Menschen zu hören, die sich für das 
                begeistern, was wir tun.
              </p>
              
              <div className="mb-4">
                <h5>In Verbindung bleiben</h5>
                <p className="text-muted">
                  Wenn Sie an zukünftigen Möglichkeiten bei Vegbox interessiert sind, senden Sie 
                  uns gerne Ihren Lebenslauf und ein Anschreiben. Wir werden Ihre Informationen 
                  aufbewahren und uns melden, wenn eine passende Position verfügbar wird.
                </p>
              </div>

              <div className="contact-info">
                <p className="mb-2">
                  <strong>Senden Sie Ihre Bewerbung an:</strong>
                </p>
                <p className="mb-3">
                  <a href="mailto:vegboxgmbh@gmail.com" className="btn btn-outline-success">
                    <i className="fas fa-envelope me-2"></i>vegboxgmbh@gmail.com
                  </a>
                </p>
              </div>

              <div className="mt-4">
                <small className="text-muted">
                  Wir sind ein Arbeitgeber für Chancengleichheit und setzen uns für Vielfalt und Inklusion ein.
                </small>
              </div>
            </div>
          </div>
          
          <div className="mt-4">
            <p className="text-muted">
              Möchten Sie mehr über unser Unternehmen erfahren? 
              <a href="/about-us" className="text-decoration-none ms-1">Besuchen Sie unsere Über uns-Seite</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsDe;